import { render, staticRenderFns } from "./wechat_management.vue?vue&type=template&id=40e11fa4&scoped=true"
import script from "./wechat_management.vue?vue&type=script&lang=js"
export * from "./wechat_management.vue?vue&type=script&lang=js"
import style0 from "./wechat_management.vue?vue&type=style&index=0&id=40e11fa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e11fa4",
  null
  
)

export default component.exports